﻿///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
(function( doc ) {
    'use strict';

    const ROOT = 'projects';
        
    class ProjectManager {
        static get cssClasses() {
            return {
                ROOT,
                filters: `${ROOT}-grid-filter`,
                projectsGrid: `${ROOT}-grid`,
                selected: 'is-selected'
            };
        }

        constructor() {
            this.processing = false;
            this.filterList = app.$( `.${ProjectManager.cssClasses.filters}` );
            this.filters = this.filterList.querySelectorAll( 'button' );
            this.projects = app.$( `.${ProjectManager.cssClasses.projectsGrid}` );
            this.addEventListeners();
        }

        addEventListeners() {
            app.$.forEach( this.filters, filter => {
                filter.addEventListener( 'click', e => this.filterProjects( e ) );
            } );
        }

        filterProjects( e ) {
            if ( this.processing ) {
                return;
            }
            this.processing = true;

            const filter = e.target;
            const type = parseInt( filter.getAttribute( 'data-id-target' ), 10 );
            filter.classList.add( 'is-loading' );

            app.$.fetch( '/api/projectsGetHTMLGrid', {
                body: {
                    propertyTypeId: type
                }
            } ).then( rsp => {
                if ( rsp.success ) {
                    this.projects.innerHTML = rsp.obj;

                    app.$.forEach( this.filters, f => {
                        f.classList.remove( ProjectManager.cssClasses.selected );
                    } );
                   
                    filter.classList.add( ProjectManager.cssClasses.selected );
                } else {
                    console.log( 'Error: ', rsp.msg );
                }
                this.processing = false;
                filter.classList.remove( 'is-loading' );
            } );

            e.preventDefault();
        }
    }

    let pm = new ProjectManager(); 

}( document ) );